// extracted by mini-css-extract-plugin
export var searchHeader = "_6u-0";
export var searchHeaderDark = "_6u-1";